import { render, staticRenderFns } from "./TrainingItemContentGenerationModal.vue?vue&type=template&id=7241b7ba&"
import script from "./TrainingItemContentGenerationModal.vue?vue&type=script&lang=js&"
export * from "./TrainingItemContentGenerationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports